import classNames from 'classnames'

import imgSizes from 'ui-component-library/utils/imgSizes'
import type { Props as CardProps } from 'ui-component-library/components/00-Primitives/ImageCaption'
import ImageCaption from 'ui-component-library/components/00-Primitives/ImageCaption'
import style from './style.scss'

const sizeProps = {
  large: imgSizes(325, 500, 600),
  medium: imgSizes(null, 325, 400),
  small: imgSizes(null, null, 325),
}

type Props = {
  cards: CardProps[]
  size: 'large' | 'medium' | 'small'
  className?: string
}

function ImageCards(props: Props) {
  const { cards, className, size } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={style.cardContainer}>
        {cards.map((card, index) => {
          const { isGradient = false, ...rest } = card
          return (
            <ImageCaption
              key={`${index}-${card.captionText}`}
              className={classNames(style.imageCaptions, style[size])}
              imageSizes={sizeProps[size]}
              isGradient={isGradient}
              {...rest}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ImageCards
